// export this package's api
import Wizard from './Wizard';
import StepComponent from './Step';
Wizard.Step = StepComponent;
export default Wizard;
export const Step = StepComponent;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/